<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show" color="#FFFF99">
                        <v-card-title>
                            <v-icon large left>mdi-files</v-icon>
                            Control de Documentos de Ingeniería
                            <v-spacer></v-spacer>
                            <div>
                                <v-btn icon @click="show = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </div>
                        </v-card-title>
                        <v-card-text class="pt-2">
                            <v-row dense>
                                <v-col cols="12" md="4">
                                    <v-select dense outlined :items="clientes" item-text="cliente" item-value="cliente"
                                        return-object label="Cliente" v-model="cliente" hide-details
                                        class="font-class-name" />
                                </v-col>
                                <v-col cols="12" md="5">
                                    <v-select dense outlined :items="obras" item-text="obra" item-value="obra"
                                        label="Obra" return-object v-model="obra" hide-details
                                        class="font-class-name" />
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-select dense outlined :items="proyectistas" item-text="nombre"
                                        item-value="codigo" return-object label="Proyectistas" v-model="proyectista"
                                        hide-details class="font-class-name" />
                                </v-col>
                                <v-col cols="12" md="1">
                                    <v-text-field dense outlined label="Fecha" v-model="fecha" hide-details
                                        class="font-class-name" />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">Destinatario</v-col>
                                <v-col cols="12" sm="2" md="2">Copias</v-col>
                                <v-col cols="12" sm="1" md="1">e-Mail</v-col>
                                <v-col cols="12" sm="5" md="5">Nombre Recibió</v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                    <v-checkbox dense label="Cliente" v-model="checkcliente" hide-details
                                        class="font-class-name"></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="2" md="2"><v-text-field dense outlined v-model="copiacliente"
                                        hide-details class="font-class-name"></v-text-field></v-col>
                                <v-col cols="12" sm="1" md="1"><v-checkbox dense v-model="mailcliente" hide-details
                                        class="font-class-name"></v-checkbox></v-col>
                                <v-col cols="12" sm="5" md="5"><v-text-field dense outlined v-model="recibiocliente"
                                        hide-details class="font-class-name"></v-text-field></v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                    <v-checkbox dense label="Jefe de Obra / Resp. Fabricación" v-model="checkjefe"
                                        hide-details class="font-class-name"></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="2" md="2"><v-text-field dense outlined v-model="copiajefe"
                                        hide-details class="font-class-name"></v-text-field></v-col>
                                <v-col cols="12" sm="1" md="1"><v-checkbox dense v-model="mailjefe" hide-details
                                        class="font-class-name"></v-checkbox></v-col>
                                <v-col cols="12" sm="5" md="5"><v-text-field dense outlined v-model="recibiojefe"
                                        hide-details class="font-class-name"></v-text-field></v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                    <v-checkbox dense label="Subcontratista" v-model="checksubcont" hide-details
                                        class="font-class-name"></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="2" md="2"><v-text-field dense outlined v-model="copiasubcont"
                                        hide-details class="font-class-name"></v-text-field></v-col>
                                <v-col cols="12" sm="1" md="1"><v-checkbox dense v-model="mailsubcont" hide-details
                                        class="font-class-name"></v-checkbox></v-col>
                                <v-col cols="12" sm="5" md="5"><v-text-field dense outlined v-model="recibiosubcont"
                                        hide-details class="font-class-name"></v-text-field></v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="4">
                                    <v-radio-group v-model="estado" row dense hide-details class="mini-radio-group">
                                        <v-radio label="Envío" value="E"></v-radio>
                                        <v-radio label="Recepción" value="R"></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-checkbox v-model="controlada" label="Copia Cotrolada" dense hide-details
                                        class="mini-check"></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card>
                        <v-card-text>
                            <v-data-table dense :headers="headers" :items="listado" :single-expand="true" locale="es-ar"
                                class="elevation-1 compact-table" :items-per-page="2000" hide-default-footer
                                :loading="loadtable" loading-text="Cargando... Espere por favor"
                                no-data-text="No hay datos disponibles">
                                <template v-slot:item.seleccionar="{ item }">
                                    <v-checkbox v-model="item.seleccionar" dense hide-details
                                        class="mini-check"></v-checkbox>
                                </template>
                                <template v-slot:item.estado="{ item }">
                                    <v-radio-group v-model="item.estado" row dense hide-details
                                        class="mini-radio-group">
                                        <v-radio label="Obs." value="B"></v-radio>
                                        <v-radio label="A.c/O" value="C"></v-radio>
                                        <v-radio label="Apr." value="D"></v-radio>
                                    </v-radio-group>
                                </template>
                                <template v-slot:item.archivootro="{ item }">
                                    <div v-if="item.archivootro == '-'">
                                        {{ item.nomplano }}
                                    </div>
                                    <div v-if="item.archivootro != '-'">
                                        {{ item.archivootro }}
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                    <v-card color="orange" dark tile>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click.stop="preliminar" :disabled="deshabilitar">Vista
                                Preliminar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
                <Ver :visible="showVer" :datos="datos" :listadofiltrado="listadofiltrado" @close="showVer = false">
                </Ver>
            </v-app>
        </div>
    </v-dialog>
</template>

<style scoped>
.font-class-name {
    font-size: 12px;
}

/* Texto general dentro de la tabla */
.v-data-table td {
    font-size: 12px;
    padding: 4px 8px !important;
}

/* Checkbox */
.mini-check .v-icon {
    font-size: 12px !important;
}

.mini-check .v-input--selection-controls__ripple {
    width: 0;
    height: 0;
}

/* Radios */
.mini-radio-group .v-icon {
    font-size: 12px !important;
}

.mini-radio-group .v-label {
    font-size: 11px;
}

/* Elimina espacios extra */
.mini-radio-group .v-input--selection-controls__input {
    margin-right: 4px;
}

.compact-table .v-input {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
}
</style>

<script>
import moment from "moment";
import axios from "../../../axios-auth";
import Ver from "../Documentos/Preliminarremito.vue";
export default {
    props: ["visible"],
    components: { Ver },
    data() {
        return {
            lazy: false,
            valid: false,
            deshabilitar: false,
            loadtable: false,
            fecha: moment().format("DD/MM/YYYY"),
            codigo: "",
            cliente: "",
            obra: "",
            proyectista: "",
            checkcliente: "",
            checkjefe: "",
            checksubcont: "",
            copiacliente: "",
            copiajefe: "",
            copiasubcont: "",
            mailcliente: "",
            mailjefe: "",
            mailsubcont: "",
            recibiocliente: "",
            recibiojefe: "",
            recibiosubcont: "",
            estado: "E",
            controlada: "",
            avance: "",
            descr: "",
            proyectistas: [],
            clientes: [],
            obras: [],
            listado: [],
            headers: [
                { text: "Seleccionar", value: "seleccionar", width: "5%", sortable: false },
                { text: "Recepción", value: "estado", width: "20%", sortable: false },
                { text: "Nombre", align: "start", sortable: false, value: "nomplano", },
                { text: "Revisión", value: "revision", sortable: false },
                { text: "Descripción", value: "descrplano", width: "30%", sortable: false },
                { text: "Archivo", value: "archivootro", sortable: false },
                { text: "Tipo", value: "tipoarchivo", sortable: false },
            ],
            showVer: false,
            datos: [],
            listadofiltrado: [],

        };
    },
    watch: {
        cliente(val) {
            if (!val) {
                this.obra = null;
                this.obras = [];
                return;
            }
            this.numcliente = this.cliente.numcliente;
            this.listadoobras();
        },
        obra(val) {
            if (val) {
                this.cargarListados();
            }
        },
    },
    computed: {
        show: {
            get() {
                //this.mostrar = true;
                //this.elaboro = this.$store.state.nombre.toString().trim();
                if (this.visible == true) {
                    this.listadoclientes();
                    this.listadoproyectistas();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        vaciarModels() {
            const initialState = this.$options.data.call(this);

            Object.keys(initialState).forEach((key) => {
                this[key] = initialState[key];
            });
        },
        listadoclientes() {
            let self = this;
            axios
                .get("/Ingenieria/Listadoclientes?", {
                    params: {
                        filtrocliente: '',
                    },
                })
                .then((response) => {
                    self.clientes = response.data;
                })
                .catch((error) => {
                    self.clientes = [];
                    console.log(error);
                });
        },
        listadoobras() {
            //this.obras = [];
            console.log("ENTRO a obras")
            let self = this;
            axios
                .get("/Ingenieria/Listadoobras?", {
                    params: {
                        filtroobra: '',
                        filtrocliente: self.numcliente,
                    },
                })
                .then((response) => {
                    self.obras = response.data;
                })
                .catch((error) => {
                    self.obras = [];
                    console.log(error);
                });
        },
        listadoproyectistas() {
            let self = this;
            axios
                .get("/Ingenieria/Listadoproyectistas?")
                .then((response) => {
                    self.proyectistas = response.data;
                })
                .catch((error) => {
                    self.proyectistas = [];
                    console.log(error);
                });
        },
        cargarListados() {
            this.loadtable = true;
            let self = this;
            axios
                .get("/Ingenieria/Listadoplanos?", {
                    params: {
                        numcliente: self.cliente.numcliente,
                        numobra: self.obra.numobra,
                        avance: "",
                        proyectista: "",
                        descrplano: "",
                    },
                })
                .then((response) => {
                    //self.listado = response.data;

                    self.listado = response.data.map(item => ({
                        ...item,
                        estado: 'B'
                    }))
                    self.loadtable = false;
                    console.log("listado ", self.listado)
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });

        },

        // vaciarModels() {
        //     this.listado = [];

        // },
        preliminar() {

            this.listadofiltrado = [];
            this.datos =
            {
                cliente: this.cliente.nomcliente,
                numcliente: this.cliente.numcliente,
                obra: this.obra.nomobra,
                numobra: this.obra.numobra,
                proyectista: this.proyectista.nomproyectista,
                fecha: this.fecha,
                checkcliente: this.checkcliente,
                copiacliente: this.copiacliente,
                mailcliente: this.mailcliente,
                recibiocliente: this.recibiocliente,
                checkjefe: this.checkjefe,
                copiajefe: this.copiajefe,
                mailjefe: this.mailjefe,
                recibiojefe: this.recibiojefe,
                checksubcont: this.checksubcont,
                copiasubcont: this.copiasubcont,
                mailsubcont: this.mailsubcont,
                recibiosubcont: this.recibiosubcont,
                estado: this.estado,
                controlada: this.controlada
            };


            // this.listadofiltrado = this.listado
            //     .filter(el => el.select === "ON")
            //     .map(el => ({
            //         estado: el.estado,
            //         descrplano: el.descrplano,
            //         nomplano: el.nomplano,
            //         archivootro: el.archivootro,
            //         tipoarchivo: el.tipoarchivo,
            //         revision: el.revision,
            //     }));
            this.listado.forEach((element) => {
                if (element.seleccionar == true) {

                    this.listadofiltrado.push({
                        estado: element.estado,
                        descrplano: element.descrplano,
                        nomplano: element.nomplano,
                        archivootro: element.archivootro,
                        tipoarchivo: element.tipoarchivo,
                        revision: element.revision,

                    });
                }
            });
            console.log("listado ", this.listado)

            this.showVer = true;
        }
    },
};
</script>
